<script lang="js">
import { models } from '@/lib/schema'
import KObjectsBase from '@/blocks/k-objects-base'
import { Logger } from '@/lib/logger'
import { preprocessActions } from '@/lib/util'

export default {
  name: 'ObjectsBlock',
  functional: true,
  props: {
    model: String,
    actions: Array,
    groupActions: Array,
  },
  render( h, ctx ) {
    const { model, actions, groupActions } = ctx.props
    const modelObject = models[ model ]
    const component = ( modelObject && modelObject.components &&
                        modelObject.components.objects &&
                        modelObject.components.objects() ) || KObjectsBase
    Logger.debug( 'ctx', '<k-objects>', ctx )()
    ctx.data.attrs.model = modelObject
    if ( actions ) {
      ctx.data.attrs.actions = preprocessActions( actions, {
        model: modelObject,
      })
    }
    if ( groupActions ) {
      ctx.data.attrs.groupActions = preprocessActions( groupActions, {
        model: modelObject,
      })
    }
    return h( component, ctx.data, ctx.children )
  }
}
</script>
